import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import SessionContext from '@providers/Session/SessionContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredApps?: string[];
  requireAll?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredApps,
  requireAll,
}) => {
  const { customer, isRoot } = useContext(SessionContext);
  const listContractTypes = customer?.customerLogged?.listContractTypes || [];

  if (!requiredApps || requiredApps.length === 0) {
    return <>{children}</>;
  }

  const hasRequiredApps =
    requireAll === false
      ? requiredApps.some(app =>
          listContractTypes.some(
            (type: string) => type.toLowerCase() === app.toLowerCase(),
          ),
        )
      : requiredApps.every(app =>
          listContractTypes.some(
            (type: string) => type.toLowerCase() === app.toLowerCase(),
          ),
        );

  if (!isRoot && !hasRequiredApps) {
    return <Navigate to="/not-found" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
